import { gql, useQuery } from "@apollo/client";
import { toaster } from "evergreen-ui";
import { auth } from "firebase";
import React, { useEffect } from "react";

export const GET_STOCK_BALANCE = gql`
  query getStockByPk($id: String!) {
    users_by_pk(id: $id) {
      id
      stock_balance
    }
  }
`;

const StockBalance = () => {
  const { data, loading, error } = useQuery(GET_STOCK_BALANCE, {
    variables: {
      id: auth().currentUser?.uid,
    },
  });

  useEffect(() => {
    if (!loading && error) {
      toaster.danger(error.message);
    }
  }, [loading, error]);
  if (!loading && data) {
    return <p>{data.users_by_pk.stock_balance}</p>;
  }

  if (error) {
    return <p>An error has occured! Try again later!</p>;
  }

  return <p>Loading...</p>;
};

export default StockBalance;
